export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const $ = (selector) => document.querySelector(selector);
export const $$ = (selector) => document.querySelectorAll(selector);
